// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Review status chip for a journal entry or a per-currency review section: "Reviewed" once nothing
 * is pending, "Pending" otherwise.
 */
import {
  CheckCircleOutlineRounded,
  PendingOutlined,
} from '@/constants/hardfin-standard-icons';
import { Chip } from '@mui/material';

interface Props {
  isReviewed: boolean;
}

export function ReviewStatusChip(props: Props) {
  if (props.isReviewed) {
    return (
      <Chip
        size="small"
        color="success"
        label="Reviewed"
        icon={<CheckCircleOutlineRounded fontSize="small" />}
      />
    );
  }

  return (
    <Chip
      size="small"
      color="default"
      label="Pending"
      icon={<PendingOutlined fontSize="small" />}
    />
  );
}
